import React, { Component, useState, Radio } from "react";

import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { InputGroup } from "react-bootstrap";
import moment from "moment";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";
import { ChangeDetectionStrategyType } from "ag-grid-react/lib/changeDetectionService";

import CustomLoadingOverlay from "./CustomLoadingOverlay";

const copyToClipBoard = (str) => {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};

const appName = [
    { name: "tomonote", desc: "토모노트" },
    { name: "tomobooks", desc: "별별책방" },
    { name: "homebooks", desc: "별별책방(3년차)" },
    { name: "tas", desc: "TAS" },
    { name: "tomoenglish", desc: "플라잉" },
    { name: "momo", desc: "모모한글수" },
    { name: "play-dd-host", desc: "딩동(클래스)" },
    { name: "play-dd-client", desc: "딩동(원아)" },
    { name: "jelliing", desc: "젤링" },
];

const getAppName = (name) => {
    return appName.find((app) => app.name === name);
};

class DeviceTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            tableSearchKeyword: null,
            tableSearchApp: null,
            isGridReady: false,
            frameworkComponents: {
                customLoadingOverlay: CustomLoadingOverlay,
            },
            loadingOverlayComponent: "customLoadingOverlay",
            loadingOverlayComponentParams: { loadingMessage: "Loading..." },
        };
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.state.isGridReady && nextProps.showLoading) {
            this.gridApi.showLoadingOverlay();
            return;
        }
        //if(nextProps.branches !== null && nextProps.devices !== null && this.props.devices !== nextProps.devices) {
        this.renderData(nextProps.devices);
        //}
    };

    renderData = (devices) => {
        var tableData = [];

        if (devices !== null && devices.length > 0) {
            devices.forEach((d) => {
                if(!this.state.tableSearchApp || this.state.tableSearchApp == d.appId) {
                    if (!this.state.tableSearchKeyword) {
                        tableData.push(d);
                    } else {
                        if (
                            d.did.indexOf(this.state.tableSearchKeyword) > -1 ||
                            d.userId.indexOf(this.state.tableSearchKeyword) > -1 ||
                            d.nurseryName.indexOf(this.state.tableSearchKeyword) > -1 ||
                            d.subscriberName.indexOf(this.state.tableSearchKeyword) > -1 ||
                            d.className.indexOf(this.state.tableSearchKeyword) > -1
                        ) {
                            tableData.push(d);
                        }
                    }
                }
            });
        }

        this.setState({ tableData: tableData }, () => {});
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.state.isGridReady = true;
        this.props.onGridReadyHandler();
    };

    onFirstDataRendered = (params) => {};

    onRowDataChanged = (params) => {
        this.setState({
            tableSummary: this.state.tableData.length.toLocaleString() + "/" + (this.props.devices ? this.props.devices.length : 0).toLocaleString(),
        });
        var allColumnIds = ["did", "userId", "branchName", "subscriberName", "nurseryName", "className", "appId"];
        params.columnApi.autoSizeColumns(allColumnIds, true);
    };
    onRowClicked = (params) => {
        if (params.api.getFocusedCell().column.getColId() === "disconnect") {
            var app = getAppName(params.data.appId);
            var appName = app ? app.desc : "알수없음";
            if (window.confirm(`해당 디바이스와 [${appName}]의 연결을 확인하고 해제하시겠습니까?`)) {
                axios({
                    method: "delete",
                    url: `/api/device/${params.data.appId}`,
                    data: {
                        id: params.data.id,
                        table: params.data.table,
                    },
                })
                    .then((res) => {
                        const response = res.data;
                        if (response.code == 200) {
                            if (response.data.disconnected > 0) {
                                this.state.tableData.splice(params.rowIndex, 1);
                                this.setState({ tableData: this.state.tableData });
                                if (this.props.onDeviceDisconnectedHandler) {
                                    this.props.onDeviceDisconnectedHandler();
                                }
                            }
                            alert(response.msg);
                        } else {
                            alert(response.msg);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        } else {
            this.props.onRowSelected(params.data.id);
        }
    };

    onSearchList = (e) => {
        var tableSearchKeyword = e.target.value;
        this.setState({ tableSearchKeyword: tableSearchKeyword });
    };

    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.renderData(this.props.devices);
        }
    };

    onSearchApp = (e) => {
        this.setState({ tableSearchApp: e.target.value }, () => this.renderData(this.props.devices));
    };

    onClickCopyAccount = (e, param) => {
        e.currentTarget.blur();
        if (param.value != null && param.value.length > 0) {
            var text = "";
            for (var i = 0; i < param.value.length; i++) {
                text += param.value[i] + "\r\n";
            }
            copyToClipBoard(text);
            this.props.toast("계정 목록을 클립보드에 복사하였습니다.", { type: this.props.toast.TYPE.INFO });
        }
    };

    onBtnExportDataAsCsv = () => {
        var fileName = "device_" + moment().format("YYYYMMDD") + ".csv";
        this.gridApi.exportDataAsCsv({ fileName: fileName });
    };

    listColumn = [
        {
            headerName: "DID",
            field: "did",
            sortable: true,
            minWidth: 170,
            pinned: "left",
            cellClass: "text-center",
            cellRenderer: (param) => {
                let cell = param.value;
                if(param.data.appId == 'play-dd-host' && param.data.useClassId) {
                    cell += `<span class="badge badge-success ml-2">사용중</span>`;
                }
                return cell;
            },
        },
        {
            headerName: "계정",
            field: "userId",
            minWidth: 80,
            pinned: "left",
            sortable: true,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "연결해제",
            field: "disconnect",
            maxWidth: 80,
            width: 80,
            pinned: "left",
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return `<button class='btn btn-danger' style='padding: 2px 6px'>해제</button>`;
            },
        },
        {
            headerName: "계정(기기) 이름",
            field: "subscriberName",
            minWidth: 110,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return (param.value ? param.value : '-') + (param.data.appId.indexOf('play-dd') > -1 ? ` (${param.data.deviceName ? param.data.deviceName : '-'})` : '');
            },
        },
        {
            headerName: "지사",
            field: "branchName",
            minWidth: 100,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "소속원",
            field: "nurseryName",
            minWidth: 100,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "클래스",
            field: "className",
            minWidth: 80,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "앱",
            field: "appId",
            minWidth: 100,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                var app = getAppName(param.value);
                return app ? app.desc : "-";
            },
        },
        {
            headerName: "버전",
            field: "version",
            maxWidth: 100,
            width: 80,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "펌웨어",
            field: "firmware",
            width: 80,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "계약",
            field: "approval",
            maxWidth: 100,
            width: 70,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value == "AP" ? `<span class="text-success">승인</span>` : param.value == "NA" ? `<span class="text-danger">해지</span>` : param.value;
            },
        },
        {
            headerName: "계약승인일",
            field: "approvalDate",
            width: 110,
            sortable: true,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.data.approval === "AP" ? moment(param.value).format("YYYY-MM-DD") : "-";
            },
        },
        {
            headerName: "계약기간",
            field: "approvalPeriod",
            width: 190,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.data.approval === "AP" ? param.data.startDate + "~" + param.data.endDate : "-";
            },
        },
        {
            headerName: "생성일",
            field: "createDate",
            width: 110,
            sortable: true,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value ? param.value.substring(0, 10) : "-";
            },
        },
        {
            headerName: "최근접속일",
            field: "lastAccess",
            width: 170,
            sortable: true,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
    ];

    render() {
        return (
            <div className="card border-top border-3 border-top-info">
                <div className="card-body" style={{}}>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-3 text-left table-total-summary">{this.state.tableSummary}</div>
                        <div className="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-9 mb-1">
                            <div className="row">
                                <div className="col-xl-4 col-lg-4 hidden-xs">
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                                    <Button className="btn btn-secondary" onClick={() => this.onBtnExportDataAsCsv()}>
                                        CSV로 저장
                                    </Button>
                                </div>
                                <div className="col-xl-2 col-lg-2 col-md-5 col-sm-5 col-5 float-right">
                                    <InputGroup className="">
                                        <InputGroup.Prepend>
                                            <InputGroup.Text style={{ width: "50px", justifyContent: "center" }}>앱</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <select className="form-control input-group-append" value={this.state.tableSearchApp} onChange={(e) => this.onSearchApp(e)} style={{ height: "auto" }}>
                                            <option value="">전체</option>
                                            {
                                                appName.map(app => {
                                                    return <option value={app.name}>{app.desc}</option>
                                                })
                                            }
                                        </select>
                                    </InputGroup>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-5 col-sm-5 col-5">
                                    <input className="form-control" type="text" onChange={(e) => this.onSearchList(e)} onKeyPress={this.handleKeyPress} placeholder="DID/계정/이름/원/클래스 검색" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                height={400}
                                columnDefs={this.listColumn}
                                defaultColDef={{ resizable: true }}
                                rowData={this.state.tableData}
                                enableCellTextSelection={true}
                                ensureDomOrder={true}
                                onGridReady={this.onGridReady}
                                onRowClicked={this.onRowClicked.bind(this)}
                                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                onRowDataChanged={this.onRowDataChanged}
                                rowDataChangeDetectionStrategy={ChangeDetectionStrategyType.IdentityCheck}
                                enableCellChangeFlash={true}
                                frameworkComponents={this.state.frameworkComponents}
                                loadingOverlayComponent={this.state.loadingOverlayComponent}
                                loadingOverlayComponentParams={this.state.loadingOverlayComponentParams}
                                overlayNoRowsTemplate={`<span>기기 목록이 없습니다.</span>`}
                                suppressSizeColumnsToFit={true}
                            ></AgGridReactEx>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeviceTable;
